var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-main common" },
    [
      _c(
        "a-tabs",
        [
          _c("a-tab-pane", { attrs: { tab: "个人信息资料" } }, [
            _c(
              "div",
              { staticClass: "common-form-inline" },
              [
                _c(
                  "a-form-model",
                  {
                    ref: "form",
                    attrs: {
                      model: _vm.form,
                      rules: _vm.rules,
                      "label-col": _vm.labelCol,
                      "wrapper-col": _vm.wrapperCol
                    }
                  },
                  [
                    _c(
                      "a-row",
                      { attrs: { gutter: 24 } },
                      [
                        _c(
                          "a-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "a-form-model-item",
                              { attrs: { label: "手机号", prop: "phone" } },
                              [
                                _c("a-input", {
                                  attrs: { maxLength: 11, disabled: "" },
                                  model: {
                                    value: _vm.form.phone,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "phone", $$v)
                                    },
                                    expression: "form.phone"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "a-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "a-form-model-item",
                              { attrs: { label: "用户姓名", prop: "name" } },
                              [
                                _c("a-input", {
                                  attrs: {
                                    maxLength: 20,
                                    disabled: _vm.isDetail
                                  },
                                  model: {
                                    value: _vm.form.name,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "name", $$v)
                                    },
                                    expression: "form.name"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "a-row",
                      { attrs: { gutter: 24 } },
                      [
                        _c(
                          "a-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "a-form-model-item",
                              {
                                attrs: {
                                  label: "身份证号",
                                  prop: "certificateNo"
                                }
                              },
                              [
                                _c("a-input", {
                                  attrs: {
                                    maxLength: 50,
                                    disabled: _vm.isDetail
                                  },
                                  model: {
                                    value: _vm.form.certificateNo,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "certificateNo", $$v)
                                    },
                                    expression: "form.certificateNo"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "a-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "a-form-model-item",
                              {
                                attrs: {
                                  label: "有效期限",
                                  prop: "documentStartDate"
                                }
                              },
                              [
                                _c("a-date-picker", {
                                  staticStyle: { width: "120px" },
                                  attrs: { valueFormat: "yyyy-MM-DD" },
                                  model: {
                                    value: _vm.form.documentStartDate,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "documentStartDate",
                                        $$v
                                      )
                                    },
                                    expression: "form.documentStartDate"
                                  }
                                }),
                                _vm._v("\n                ~\n                "),
                                _c("a-date-picker", {
                                  staticStyle: {
                                    width: "120px",
                                    "margin-right": "10px"
                                  },
                                  attrs: {
                                    valueFormat: "yyyy-MM-DD",
                                    disabled: _vm.form.longTermStatus
                                  },
                                  model: {
                                    value: _vm.form.documentEndDate,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "documentEndDate", $$v)
                                    },
                                    expression: "form.documentEndDate"
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "a-checkbox",
                                  {
                                    on: { change: _vm.longTermStatusChange },
                                    model: {
                                      value: _vm.form.longTermStatus,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "longTermStatus",
                                          $$v
                                        )
                                      },
                                      expression: "form.longTermStatus"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                  长期\n                "
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "a-row",
                      { attrs: { gutter: 24 } },
                      [
                        _c(
                          "a-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "a-form-model-item",
                              {
                                attrs: {
                                  label: "身份证影像",
                                  prop: "IDcardFlag"
                                }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "spaceLeft",
                                    staticStyle: { width: "500px" }
                                  },
                                  [
                                    _c(
                                      "div",
                                      [
                                        _c("imgUpload", {
                                          attrs: {
                                            file: _vm.IDcardzheng,
                                            disabled: _vm.isDetail,
                                            paramObj: _vm.paramObj1,
                                            text: "上传证件正面",
                                            name: "file"
                                          },
                                          on: {
                                            remove: _vm.removeOk,
                                            uploadOk: _vm.uploadOk
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      [
                                        _c("imgUpload", {
                                          attrs: {
                                            disabled: _vm.isDetail,
                                            file: _vm.IDcardfan,
                                            paramObj: _vm.paramObj2,
                                            text: "上传证件背面",
                                            name: "file"
                                          },
                                          on: {
                                            remove: _vm.removeOk,
                                            uploadOk: _vm.uploadOk
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ]
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "spaceCenter model-footer-btns" },
        [
          _c(
            "a-button",
            { staticClass: "btn-blue-line btn-big", on: { click: _vm.goback } },
            [_vm._v("返回")]
          ),
          _vm._v(" "),
          !_vm.isDetail
            ? _c(
                "a-button",
                {
                  staticClass: "btn-big",
                  attrs: { type: "primary" },
                  on: { click: _vm.save }
                },
                [_vm._v("保存")]
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0ee05c45", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0ee05c45","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/security/personalAuthentication/editPage.vue
// module id = ejju
// module chunks = 1